<template>
  <div :class="getDivClass()">
    <input
      :id="id"
      :checked="checked"
      :name="name"
      :value="value"
      :class="[{ 'is-invalid': invalid }, ...getInputClass()]"
      type="checkbox"
      @change="$emit('change', !checked)"
    />
    <label
      :v-if="label != ''"
      :class="getLabelClass()"
      :for="id"
      v-text="label"
    />
  </div>
</template>
<script>
import uniqid from "uniqid";

export default {
  name: "ACheckbox",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    id: {
      type: String,
      default: () => uniqid("checkboxId-")
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    custom: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getDivClass() {
      return this.custom ? "custom-control custom-checkbox" : "form-check";
    },
    getInputClass() {
      return this.custom ? "custom-control-input" : "form-check-input";
    },
    getLabelClass() {
      return this.custom ? "custom-control-label" : "form-check-label";
    }
  }
};
</script>

<style lang="scss">
.table {
  .form-check {
    padding: 0;
  }
  .form-check-input {
    margin-left: 0;
  }
}
</style>
